// src/api/approval.js
import api from "./axios";
import rawAxios from "axios";

/** 공통 */
function getBase() {
  const base = process.env.REACT_APP_API_BASE || "/api";
  return base.endsWith("/") ? base : `${base}/`;
}
function getAuthHeader() {
  const token = localStorage.getItem("access");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** 문서 유형 저장/수정
 * - 기본: POST /api/approval/types/save/?project=...
 * - (선택) REST: POST /api/approval/types/
 */
export const saveApprovalDocType = (payload, { useRest = false } = {}) => {
  const url = useRest ? "approval/types/" : "approval/types/save/";
  return api.post(url, payload);
};

/** 결재 문서 저장/상신
 * - POST /api/approval/save/new/?project=...
 */
// src/api/approval.js (또는 saveApprovalDocument 정의 위치)
export async function saveApprovalDocument(payload) {
  const fd = new FormData();
  fd.append("title", payload.title);
  fd.append("doc_type_id", payload.docTypeId); // ✅ id
  fd.append("doc_type_code", payload.docTypeCode || ""); // ✅ code
  fd.append("is_urgent", payload.isUrgent ? "true" : "false");
  fd.append("content", payload.content || "");
  if (payload.attachment) fd.append("attachment", payload.attachment);

  return api.post(`/approval/save/new/`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

/** 보기(뷰) */
export const viewApprovalDocument = async (documentId) => {
  const base = getBase();
  const headers = getAuthHeader();
  const url = `${base}approval/doc/${encodeURIComponent(documentId)}/`;
  const r = await rawAxios.get(url, { headers });
  return r.data;
};

/** 첨부 다운로드 URL */
export const buildAttachmentDownloadUrl = (documentId) =>
  `${getBase()}approval/doc/${encodeURIComponent(documentId)}/download/`;

/** 결재 취소 */
export const cancelApprovalDocument = (dns, projectId) =>
  api.post(`approval/${encodeURIComponent(dns)}/cancel/`, null, {
    params: { project: projectId },
  });

/** 즐겨찾기 결재선 */
export const listCustomApprovalLines = (projectId) =>
  api.get("approval/custom-line/list/", { params: { project: projectId } });

export const saveCustomApprovalLine = ({ name, approvers }, projectId) =>
  api.post(
    "approval/custom-line/",
    { name, approvers },
    { params: { project: projectId } }
  );

export const deleteCustomApprovalLine = (lineId, projectId) =>
  api.delete(`approval/custom-line/${lineId}/`, {
    params: { project: projectId },
  });

/** 결재선/참조 저장 */
export const saveApprovalLinesForDocument = (payload, projectId) =>
  api.post("approval/lines/save/", payload, { params: { project: projectId } });

/** 결재선 view */
export const viewApprovalLine = (dns) =>
  api.get("approval/lines/view", { params: { dns } });

/** 내 승인 요약 */
export const getMyApprovalSummary = (projectId) =>
  api.get("approval/dashboard/approval-summary/", {
    params: { project: projectId },
  });

/** 결재선 추가 (기존 결재선 유지, append 방식) */
export const addApprovalLine = (payload, projectId) =>
  api.post("approval/line/add/", payload, { params: { project: projectId } });
